// extracted by mini-css-extract-plugin
export default {"EmptyState":"Proformas_EmptyState__nZaVa","Invoices":"Proformas_Invoices__2kWSl","InvoicesList":"Proformas_InvoicesList__ibZWf","InvoicesHeader":"Proformas_InvoicesHeader__H0fHN"};